import BaseReducer from "./BaseReducer";

class UploadReducer extends BaseReducer {
  domain = "Upload";
  type = "View";

  initialState = {
    loadingImages: false,
    incidentId: 0,
    imageList: [],
    progress: 0,
  };
}

const reducer = new UploadReducer();

export default reducer;
